import { useEffect, useState } from "react";
import { api, gbp } from "../../lib/api";

const Stat = ({ label, value, accent }) => (
  <div className="border border-[#27272A] p-6 bg-[#111111]">
    <div className="text-[10px] uppercase tracking-widest text-white/40 mb-2">{label}</div>
    <div className={`font-display text-3xl ${accent || "text-white"}`}>{value}</div>
  </div>
);

export const AdminAnalytics = () => {
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get("/admin/analytics").then(({ data }) => setA(data));
  }, []);

  if (!a) return <div className="font-display text-2xl text-white/30">LOADING NUMBERS…</div>;

  const maxRev = Math.max(1, ...a.days.map((d) => d.revenue));

  return (
    <div className="space-y-10" data-testid="admin-analytics">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Paid revenue" value={gbp(a.paid_revenue)} accent="text-[#FFCC00]" />
        <Stat label="Awaiting payment" value={gbp(a.pending_revenue)} accent="text-[#FF3B30]" />
        <Stat label="Total orders" value={a.orders_total} />
        <Stat label="Members" value={a.members} />
        <Stat label="Newsletter subs" value={a.newsletter} />
        <Stat label="WhatsApp subs" value={a.whatsapp} />
        <Stat label="Deal alerts set" value={a.watchlist} />
        <Stat label="Abandoned baskets" value={a.abandoned_baskets} accent="text-[#FF3B30]" />
      </div>

      <div className="border border-[#27272A] p-6">
        <h3 className="font-display text-2xl mb-6">REVENUE — LAST 14 DAYS</h3>
        <div className="flex items-end gap-1.5 h-40" data-testid="analytics-revenue-chart">
          {a.days.map((d) => (
            <div key={d.day} className="flex-1 h-full flex flex-col items-center justify-end gap-2 group">
              <div className="text-[10px] text-[#FFCC00] opacity-0 group-hover:opacity-100">{gbp(d.revenue)}</div>
              <div
                className="w-full bg-[#FFCC00] hover:bg-[#FF3B30] transition-colors duration-150"
                style={{ height: `${Math.max(2, (d.revenue / maxRev) * 75)}%` }}
                title={`${d.day}: ${gbp(d.revenue)} (${d.orders} orders)`}
              />
              <div className="text-[9px] text-white/30 rotate-0">{d.day}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        <div className="border border-[#27272A] p-6">
          <h3 className="font-display text-2xl mb-6">TOP SELLERS (UNITS)</h3>
          <div className="space-y-3" data-testid="analytics-top-deals">
            {a.top_deals.map((t, i) => (
              <div key={t.title} className="flex items-center gap-4 text-sm">
                <span className="font-display text-xl text-[#27272A] w-8">{String(i + 1).padStart(2, "0")}</span>
                <span className="flex-1 text-white/70 truncate">{t.title}</span>
                <span className="text-[#FFCC00] font-bold">{t.qty}</span>
              </div>
            ))}
            {a.top_deals.length === 0 && <div className="text-white/30 text-sm">No sales yet.</div>}
          </div>
        </div>
        <div className="border border-[#27272A] p-6">
          <h3 className="font-display text-2xl mb-6">LIVE DEAL SELL-THROUGH</h3>
          <div className="space-y-4" data-testid="analytics-sell-through">
            {a.sell_through.map((s) => (
              <div key={s.title}>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-white/60 truncate mr-3">{s.title}</span>
                  <span className="text-white/40 shrink-0">{s.sold}/{s.total} lots</span>
                </div>
                <div className="h-2 bg-[#27272A]">
                  <div className="h-full bg-[#FF3B30]" style={{ width: `${(s.sold / s.total) * 100}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
